
export const setTabDocument = (state, data) => {
  state.tabDocument = data
}

export const setDocumentVisibleColumns = (state, data) => {
  state.documentVisibleColumns = data
}
export const setOrdenVisibleColumns = (state, data) => {
  state.ordenVisibleColumns = data
}
